import {
  CategoryItemDto,
  CategoryItemModel,
  mapCategoryItemDtoToModel,
} from 'api/dto/new/SummaryCompared/Categories/CategoryItem.dto';
import {
  mapSummaryItemDtoToModel,
  SummaryItemDto,
  SummaryItemModel,
} from 'api/dto/new/SummaryCompared/SummaryItem.dto';
import { RespondentProtectionEnumNullable } from 'model/RespondentProtection';

export type SummaryPulseComparedDto = {
  categories: ReadonlyArray<CategoryItemDto>;
  scoreLabel: string;
  combineModeLock: boolean;
  groups: Record<string, string>;
  protections: Record<string, RespondentProtectionEnumNullable>;
  summary: ReadonlyArray<SummaryItemDto>;
  closedAtDate: string;
};

export type SummaryPulseComparedModel = {
  categories: ReadonlyArray<CategoryItemModel>;
  scoreLabel: string;
  combineModeLock: boolean;
  groups: Record<string, string>;
  protections: Record<string, RespondentProtectionEnumNullable>;
  summary: ReadonlyArray<SummaryItemModel>;
  closedAtDate: string;
};

export const mapSummaryPulseComparedDtoToModel = (
  dto: SummaryPulseComparedDto
): SummaryPulseComparedModel => ({
  categories: dto.categories.map(mapCategoryItemDtoToModel),
  scoreLabel: dto.scoreLabel,
  combineModeLock: dto.combineModeLock,
  groups: dto.groups,
  protections: dto.protections,
  summary: dto.summary.map(mapSummaryItemDtoToModel),
  closedAtDate: dto.closedAtDate,
});
